import { useLocation } from "react-router-dom";
import Purchase from "./shop-purchase";
import CellPhoneForm from "./shop-cellPhone";
import NgnShopSelectline from "./ngn-shop-selectLine";

export interface IShopProps {
  medium?: number;
}

export interface UserData {
  name: string | null;
  code: number | null;
  isSupportUser: boolean;
}

export default function Shop() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const hasSerial = queryParams.has("tariffId");
  const tariffIdParam = queryParams.get("tariffId");
  const modemIdParam = queryParams.get("modemId");
  const shippingId = Number(queryParams.get("shippingId"));
  const tariffId = tariffIdParam ? Number(tariffIdParam) : undefined;
  const modemId = modemIdParam ? Number(modemIdParam) : undefined;
  const tags = queryParams.get("tags");
  const typeParam = queryParams.get("type");
  const type = typeParam ? Number(typeParam) : undefined;

  const ngnNumber = queryParams.get("number");
  console.log("type", type);
  console.log("ngnNumber", ngnNumber);
  console.log("modemId", modemId);
  console.log("tags", tags);

  if (hasSerial && tariffId !== undefined && type !== undefined) {
    return (
      <CellPhoneForm
        type={type}
        tariffId={tariffId}
        shippingId={shippingId}
        modemId={modemId}
        tags={tags!}
      />
    );
  }

  if (type === 40 && ngnNumber == null) {
    return <NgnShopSelectline />;
  }

  if (type !== undefined || ngnNumber !== null) {
    return (
      <Purchase
        type={type}
        number={ngnNumber!}
        shippingId={shippingId}
        tags={tags!}
      />
    );
  }

  return <div>Invalid shop parameters</div>;
}
